exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2.baseline[data-v-b285937a]{color:#68b8b7}.list-inline[data-v-b285937a]{display:block}.list-inline li[data-v-b285937a]{display:inline-block;margin-right:0}.list-inline li[data-v-b285937a]:after{content:\"|\";margin:0 10px}.list-inline li[data-v-b285937a]:last-child:after{content:\"\"}", ""]);

// exports
